import React, { createContext, useContext, useEffect, useState } from 'react';
import { isClarityBot, isClaritySnapshotRoute } from '@/lib/detectClarityBot';

interface ClarityContextType {
  isClarityMode: boolean;
  isSnapshotRoute: boolean;
}

const ClarityContext = createContext<ClarityContextType>({
  isClarityMode: false,
  isSnapshotRoute: false,
});

export const useClarityMode = () => useContext(ClarityContext);

interface ClarityProviderProps {
  children: React.ReactNode;
}

export const ClarityProvider: React.FC<ClarityProviderProps> = ({ children }) => {
  const [isClarityMode, setIsClarityMode] = useState(false);
  const [isSnapshotRoute, setIsSnapshotRoute] = useState(false);

  useEffect(() => {
    const clarityDetected = isClarityBot();
    const snapshotRoute = isClaritySnapshotRoute();
    
    setIsClarityMode(clarityDetected || snapshotRoute);
    setIsSnapshotRoute(snapshotRoute);

    // Add class to body for CSS targeting
    if (clarityDetected || snapshotRoute) {
      document.body.classList.add('clarity-mode');
      document.documentElement.classList.add('clarity-mode');
    }
  }, []);

  return (
    <ClarityContext.Provider value={{ isClarityMode, isSnapshotRoute }}>
      {children}
    </ClarityContext.Provider>
  );
};
